const TRON_ADDRESS_PATTERN = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;

export function buildTronEnergyOrderSearchParams(value?: string): {
  orderNo?: string;
  receiverAddress?: string;
} {
  const searchValue = (value || '').trim();
  if (!searchValue) {
    return {};
  }
  if (TRON_ADDRESS_PATTERN.test(searchValue)) {
    return { receiverAddress: searchValue };
  }
  return { orderNo: searchValue };
}
